import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { AbstractApiService } from '@core/Interceptor/jsonrpc.abstract';
import { Users } from './auth.model';
import { lastValueFrom, map } from 'rxjs';
import { StorageMap } from '@ngx-pwa/local-storage';
import { environment } from 'src/environments/environment';
import { GTMService } from '@core/Services/gtm.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends AbstractApiService<any> {

  token:any //token in DOM
  bypass: any;

  public users = signal<Users | null>(null);
  user!: Users;

  constructor(
    http:HttpClient, private storage: StorageMap
  ) {
    super(http,'null');
  }

  staticLogin(data:any){
    return this.post(data,'/auth/loginStatic');
  }

  loginCode(data:any){
    return this.post(data,'/auth/invitation');
  }

  loginWithCode(code:any, utm_source:any, utm_campaign:any, utm_leads:any, capchatoken:any, isAcceptBCALife:any, reg:any) {
    let body = new FormData();
    body.append("code", code);
    body.append("utm_source", utm_source);
    body.append("utm_campaign", utm_campaign);
    body.append("utm_leads", utm_leads);
    body.append("token", capchatoken);
    body.append("reg", JSON.stringify(reg));
    body.append("isAttendOffline",'1');
    body.append("isAcceptBCALife", reg.isAcceptBCALife);
    return this.http
      .post<any>(`${environment.apiUrl}/auth/invitation`, body)
      .pipe(
        map((resData) => {
          return resData;
        })
      );
  }

  register(formData: any) {
    //console.log(formData)
    let body = new FormData();
    body.append("email", formData.email);
    body.append("phone", formData.phone.replace(/\s/g, ""));
    body.append("name", formData.name);
    body.append("regency_id", formData.regency_id);
    body.append("utm_source", formData.utm_source);
    body.append("utm_campaign", formData.utm_campaign);
    body.append("utm_leads", formData.utm_leads);
    body.append("kantorCabang", formData.kantorCabang);
    body.append("isAttendOffline", formData.isAttendOffline);
    body.append("isAcceptBCALife", formData.isAcceptBCALife);
    body.append("isAcceptTNC", formData.isAcceptTNC)
    body.append("token", formData.token);
    return this.post(body, "/auth/loginRegister");
  }

  getDataUsers(): Promise<any> {
    return this.getAll({}, "/users").then((res) => {
      if (res.data) {
        //console.log(res)
        this.users.set(res.data);
        return res.data;
      }
    });
  }

  updateData(formData: any) {

    let body = new FormData();
    // body.append("email", formData.email);
    body.append("phone", formData.phone);
    body.append("name", formData.name);
    body.append("email", formData.email);
    body.append("regency_id", formData.regency_id);
    body.append("kantorCabang", formData.kantorCabang);
    body.append("isAttendOffline", formData.isAttendOffline);
    body.append("isAcceptBCALife", formData.isAcceptBCALife);
    body.append("isAcceptTNC", formData.isAcceptTNC)

    return this.post(body, "/users");
  }

  updateProfile2(name:string, formData:any,){

    let body = new FormData();
    // body.append("email", formData.email);
    body.append("phone", formData.phone);
    body.append("name", name);
    // body.append("email", formData.email);
    body.append("regency_id", formData.location);


    return this.post(body, "/users");

  }

  setStatusData(){

    let body = {
      "is_data_checked": true
    }

    return this.post(body, "/users/hasCheckedData");

  }

  getMyNotif(page:number, limit:number, keywoard:string) {
    var token = this.token;

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    return this.http.get<any>(
      `${environment.apiUrl}/users/notifications?type=notification&&limit=${limit}&page=${page}`, httpOptions
    );
  }

  async logout() {

    this.token = null;
    this.users.set(null);
    await lastValueFrom(this.storage.clear());

    window.location.reload();
  }

  async logoutNOREDIRECT(type = 0) {
    // if (this.myFirebaseListener) {
    //   this.myFirebaseListener.off();
    // }
    this.token = null;
    this.users.set(null);
    // Plugins.Storage.remove({ key: 'authData' });
    // Plugins.Storage.remove({ key: 'token2' });
    await lastValueFrom(this.storage.clear());
  }


}
